<template>
  <div
    :class="[$style.context_body_multiselect]"
  >
    <div
      v-if="items.length > 15"
      :class="[$style.context_body_search, 'multiselect_context']"
    >
      <div :class="[$style.context_body_search_input]">
        <vgp-input
          v-model="searchStr"
          :style="{outline: '#fff'}"
          :class="'search-input'"
          :type="'text'"
          :placeholder="locale('search_projects_placeholder')"
          :icons-left="[
            { name: 'search' }]"
          :small="true"
          :select-by-focus="false"
        />
      </div>
    </div>
    <div
      :class="[$style.multiselect_items, 'gantt_scroll', 'multiselect_context']"
    >
      <template v-if="visibleItems.length">
        <div
          v-for="item in visibleItems"
          :key="item.value"
          :class="[
            $style.menu_item,
            item.selected && !(item.isMultiselect && item.value !== 'empty') ? $style.selected : '',
            item.selected ? 'selected_menu_item' : '',
            item.disabled ? $style.disabled : '',
            item.divider ? $style.divider : ''

          ]"
          :data-menu-type="`${item.type}:${item.menu}`"
          @click="selectItem(item)"
        >
          <div
            :class="$style.item_content"
          >
            <div
              v-if="item.value !== 'empty'"
              :class="[$style.checkbox, item.selected ? $style.selected : '']"
            >
              <svg-sprite
                name="check"
                type="regular"
                :size="16"
                :style="{ color: '#FFFFFF' }"
              />
            </div>
            <div
              v-if="item.icon"
              :class="$style.icon"
              :style="{
                background: item.isColorField ? item.name : ''
              }"
            >
              <img
                v-if="item.iconType === 'img'"
                :src="item.icon"
              >
              <svg-sprite
                v-else
                :name="item.icon"
                :type="item.iconType"
                :size="item.iconSize"
                :style="{ color: item.iconSelectedColor && item.selected ? item.iconSelectedColor : item.iconColor}"
              />
            </div>
            <div
              v-if="!item.isColorField"
              :class="[$style.label, item.labelBg ? $style.is_label_field : '' ]"
              :style="{
                color: item.labelColor || '',
                background: item.labelBg || ''
              }"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          :class="$style.no_matches"
        >
          {{ locale('no_matches_message_text') }}
        </div>
      </template>
    </div>
    <div
      v-if="multiselectChanges"
      :class="$style.multiselect_submit"
    >
      <vgp-button
        :class="$style.multiselect_submit_button"
        type="primary"
        small
        :label="locale('common_ok')"
        @onClick="submitMultiselect"
      />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  emits: [
    'selectItems',
  ],
  data() {
    return {
      locale: __,
      multiselectChanges: false,
      localSelected: [],
      searchStr: '',
    };
  },
  computed: {
    visibleItems() {
      return this.localSelected.filter(item => item.name.toLowerCase().includes(this.searchStr.toLowerCase()));
    }
  },
  watch: {
    items: {
      handler(val) {
        this.localSelected = val.map(item => ( {...item} ));
      },
      immediate: true,
    },

  },
  beforeUnmount() {
    this.localSelected = [];
    this.searchStr = '';
  },
  methods: {
    selectItem(item) {
      this.localSelected = this.localSelected.map(i => {
        if (item.value === 'empty') {
          i.selected = i.value === item.value;
        } else if (i.value === item.value) {
          i.selected = !i.selected;
        } else if (i.value === 'empty') {
          i.selected = false;
        }

        return i;
      });

      this.multiselectChanges = !_.isEqual(this.items, this.localSelected);
    },
    submitMultiselect() {
      const selectedValues = this.localSelected.filter(i => i.selected);

      this.$emit('selectItems', selectedValues);
    },
  },
};
</script>

<style module src="../less/contextMenu.less"></style>
